module.exports = __webpack_public_path__ + "img/1.71a30ff1.jpg";